/*
 *	Detect Perf
 *	Detect Performance on init. Can be used to prevent animations from happening on slower devices
 */
import { PERF } from '../const/perf.const';
import { detectIE } from './detectBrowser.util';

let perf: PERF;

const getPerfs = (): number => {
	const array = [];
	const start = (window.performance || Date).now();

	for (let i = 0; i < 20000; i += 1) {
		const calculation = Math.sin(Math.random()) ** 2;
		array.push(calculation);
	}

	const end = (window.performance || Date).now();
	return end - start;
};

export const detectPerf = (): void => {
	const isInternetExplorer = detectIE();

	if (isInternetExplorer) {
		perf = PERF.PERF_BAD;
	} else {
		const timing = getPerfs();

		if (timing < 7) {
			perf = PERF.PERF_HIGH;
		} else if (timing < 14) {
			perf = PERF.PERF_GOOD;
		} else if (timing < 22) {
			perf = PERF.PERF_LOW;
		} else {
			perf = PERF.PERF_BAD;
		}
	}
};

export const getPerf = (): PERF => perf;
